<div class="w-100 d-flex justify-content-center">
    <div style="height:200px;"></div>
    <div class="spinner-border text-danger"></div>
    <div style="height:200px;"></div>
</div>